<template>
  <div class="image-component d-flex justify-content-center align-items-center">
    <img
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
    >
  </div>
</template>

<script>
export default {
    name: 'ImageComponent',
    props: {
        src: {
            type: String,
            required: true
        },
        alt: {
            type: String,
            default: ''
        },
        width: {
            type: [String, Number],
            default: 'auto'
        },
        height: {
            type: [String, Number],
            default: 'auto'
        }
    }
}
</script>

<style scoped>
.image-component img {
    display: block;
    max-width: 100%;
    height: auto;
}
</style>